module.exports = __webpack_public_path__ + "img/login_material3.d154b0cb.png";